import { FC, Dispatch, SetStateAction } from 'react';
import cx from 'classnames/bind';
import { useMediaQuery } from 'react-responsive';

import { Layout } from '@/components/Layout';
import { Hint } from '@/components/Hint';
import { Buyer } from '@/components/Buyer';
import CashboxDesktop from '@/assets/cashboxDesktop.png';
import { SwiperScenario } from '../SwiperScenario';
import type { IGame } from '@/types/game';

import styles from './Step1.module.scss';

interface Step1Props {
  setStep: (value: number) => void;
  setIdGame: Dispatch<SetStateAction<number>>;
  setNumberQuestion: Dispatch<SetStateAction<number>>;
  numberQuestions: number;
  idGame: number;
  scenarios: IGame[];
  currentScenarioIndex: number;
  setCurrentScenarioIndex: Dispatch<SetStateAction<number>>;
  costPerQuestion: number;
}

const cn = cx.bind(styles);

const Step1: FC<Step1Props> = ({
  setStep,
  setIdGame,
  setNumberQuestion,
  numberQuestions,
  idGame,
  scenarios,
  currentScenarioIndex,
  setCurrentScenarioIndex,
  costPerQuestion,
}) => {
  const isDesctop = useMediaQuery({ query: '(min-width: 1440px)' });

  const currentScenario = scenarios.find(({ id }) => id === idGame);
  const points = currentScenario?.score;
  const isSuccessGame = currentScenario?.achievement;
  const isCompletedGame = currentScenario?.status;
  const isScenarioWithoutPoints = !currentScenario?.isScore;

  return (
    <>
      <div className={cn('background')} />
      <Buyer idGame={idGame} scenarios={scenarios} />
      {isDesctop && (
        <img src={CashboxDesktop} className={cn('imgCashbox')} alt="Касса" />
      )}
      <Layout className={cn('container')}>
        <div className={cn('wrap')}>
          {isScenarioWithoutPoints ? (
            <Hint className={cn('hint')} receivedPoints={points}>
              Пройдите обучение прежде чем приступить к сценариям
            </Hint>
          ) : isCompletedGame && typeof points === 'number' ? (
            <Hint
              className={cn('hint')}
              receivedPoints={points}
              points={numberQuestions * costPerQuestion}
            >
              За прохождение
              <br />
              вы уже получили
            </Hint>
          ) : (
            <Hint
              className={cn('hint')}
              points={numberQuestions * costPerQuestion}
            >
              За прохождение
              <br />
              вы можете получить
            </Hint>
          )}
          {scenarios.length !== 0 && (
            <div className={cn('card')}>
              <div>
                {isCompletedGame && !isSuccessGame && (
                  <div className={cn('badge')}>Сценарий не пройден</div>
                )}
                {isScenarioWithoutPoints ? (
                  <Hint className={cn('hint')} receivedPoints={points}>
                    Пройдите обучение прежде чем приступить к сценариям
                  </Hint>
                ) : isCompletedGame && typeof points === 'number' ? (
                  <Hint
                    className={cn('hint')}
                    receivedPoints={points}
                    points={numberQuestions * costPerQuestion}
                  >
                    За прохождение
                    <br />
                    вы уже получили
                  </Hint>
                ) : (
                  <Hint
                    className={cn('hint')}
                    points={numberQuestions * costPerQuestion}
                  >
                    За прохождение
                    <br />
                    вы можете получить
                  </Hint>
                )}
                <SwiperScenario
                  setStep={setStep}
                  setIdGame={setIdGame}
                  setNumberQuestion={setNumberQuestion}
                  scenarios={scenarios}
                  idGame={idGame}
                  currentScenarioIndex={currentScenarioIndex}
                  setCurrentScenarioIndex={setCurrentScenarioIndex}
                />
              </div>
            </div>
          )}
        </div>
      </Layout>
    </>
  );
};

export default Step1;
